import React from "react";
import ReactGA from "react-ga4";
import { RouteComponentProps } from "react-router-dom";

export const TRACKER_ID = "G-E4LP07DTRK";

ReactGA.initialize(TRACKER_ID, {
  testMode: process.env.NODE_ENV === "test",
});

export default <P extends RouteComponentProps>(WrappedComponent: React.ComponentType<P>, options = {}) => {
  const trackPage = (page: string) => {
    ReactGA.set({ page, ...options });
    ReactGA.send({ hitType: "pageview", page });
  };

  return (props: P) => {
    const {
      location: { pathname },
    } = props;
    React.useEffect(() => {
      trackPage(pathname);
    }, [pathname]);

    return <WrappedComponent {...props} />;
  };
};
